import React from "react";
import {
	BooleanInput,
	Datagrid,
	EditButton,
	Filter,
	List,
	SelectInput,
	ShowButton,
	TextField,
	TextInput,
	BooleanField,
	usePermissions,
} from "react-admin";
import { CustomDeleteButtonWithCustomConfirm } from "../../customComponents/CustomButtons";
import {
	constants,
	authMethodsArr,
	subscriptionTypesArr,
	rolesGlobal,
} from "../../utils/constants";

const MemberFilter = ({ ...props }) => (
	<Filter {...props}>
		<TextInput source="search" alwaysOn />
		<BooleanInput source="verified" label="Is Verified" />
		<BooleanInput source="isDeleted" label="Is Deleted" />
		<SelectInput source="method" choices={authMethodsArr} />
		<SelectInput source="subscriptionType" choices={subscriptionTypesArr} />
	</Filter>
);

export const MemberList = (props) => {
	const { permissions, isLoading } = usePermissions();
	if (isLoading) return null;
	const hideActions = permissions?.includes(rolesGlobal.coach);

	return (
		<List
			{...props}
			perPage={constants.perPage}
			bulkActionButtons={false}
			filters={<MemberFilter />}
		>
			<Datagrid>
				<TextField source="firstName" />
				<TextField source="gender" />
				<TextField source="verified" />
				<TextField source="email" />
				<TextField source="country" label="Country" />
				<BooleanField source="consented" label="PP Consented" valueLabelTrue="Yes" valueLabelFalse="No" />
				<TextField source="phoneNumber" />
				<TextField source="method" />
				<TextField source="subscriptionType" />
				<TextField source="revokeDate" />
				<BooleanField source="isDeleted" label={"Is Deleted"} />
				<ShowButton />
				{hideActions === false && <EditButton />}
    			{hideActions === false && <CustomDeleteButtonWithCustomConfirm mutationMode="pessimistic" />}
			</Datagrid>
		</List>
	);
};
